import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _div, _Components$ErrorOver, _Components$Overlay, _Components$Logo, _Components$MiddleCon, _Components$BottomCon, _Components$Menu, _Components$QualityWa, _Components$GenerateN;
import { Fragment, useEffect, useRef } from 'react';
import { cn } from '@crehana/compass.ui/utils';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Loader } from '@crehana/ui';
import { getDeviceSO } from '@crehana/utils';
import Components from "./components";
import { VIDEO_LOAD_TIMEOUT, VIDEO_LOAD_TIMEOUT_ERROR_MESSAGE } from "./constants";
import { useFullscreenContext } from "./context/Fullscreen";
import { useHlsContext } from "./context/Hls";
import { usePlaybackContext } from "./context/Playback";
import { useResponsiveContext } from "./context/Responsive";
import { useSubtitleContext } from "./context/Subtitle";
import { useUIContext } from "./context/UI";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CrehanaPlayer = function CrehanaPlayer(_ref) {
  var _header$back;
  var playerRef = _ref.playerRef,
    className = _ref.className,
    htmlProps = _ref.htmlProps,
    forcePlayerErrorState = _ref.forcePlayerErrorState,
    poster = _ref.poster,
    orientation = _ref.orientation,
    aspectRatio = _ref.aspectRatio,
    inactivity = _ref.inactivity,
    publicNotes = _ref.publicNotes;
  var _getDeviceSO = getDeviceSO(),
    isIOS = _getDeviceSO.isIOS;
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var _useFullscreenContext = useFullscreenContext(),
    isFullscreen = _useFullscreenContext.isFullscreen;
  var _usePlaybackContext = usePlaybackContext(),
    nextVideo = _usePlaybackContext.nextVideo,
    loading = _usePlaybackContext.loading,
    isReady = _usePlaybackContext.isReady,
    isPlaying = _usePlaybackContext.isPlaying,
    isStarted = _usePlaybackContext.isStarted,
    isEnded = _usePlaybackContext.isEnded,
    currentSource = _usePlaybackContext.currentSource;
  var _useSubtitleContext = useSubtitleContext(),
    currentExternalSubtitles = _useSubtitleContext.currentExternalSubtitles,
    hasVisibleTextTrack = _useSubtitleContext.hasVisibleTextTrack;
  var _useHlsContext = useHlsContext(),
    playerErrorState = _useHlsContext.playerError,
    onError = _useHlsContext.onError,
    loadingAudio = _useHlsContext.loadingAudio,
    withLowQualityWarning = _useHlsContext.withLowQualityWarning,
    withManualHighQualityWarning = _useHlsContext.withManualHighQualityWarning;
  var _useUIContext = useUIContext(),
    header = _useUIContext.header,
    hideLogo = _useUIContext.hideLogo,
    endOverlay = _useUIContext.endOverlay,
    visibleUi = _useUIContext.visibleUi,
    hiddenNotes = _useUIContext.hiddenNotes,
    hideUi = _useUIContext.hideUi,
    onMouseMove = _useUIContext.onMouseMove,
    onMouseDown = _useUIContext.onMouseDown,
    onTouch = _useUIContext.onTouch,
    showGeneratedAI = _useUIContext.showGeneratedAI;
  var playerError = playerErrorState || forcePlayerErrorState;
  var isLoading = (!isReady || loading || loadingAudio) && !isPlaying && !playerError;
  var loadTimeout = useRef();

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    if (loadTimeout.current) {
      clearTimeout(loadTimeout.current);
    }
    if (isLoading) {
      loadTimeout.current = window.setTimeout(function () {
        onError(VIDEO_LOAD_TIMEOUT_ERROR_MESSAGE);
      }, VIDEO_LOAD_TIMEOUT * 1000);
    }
    // Ignoring the onError prop, assuming it doesn't change after the first render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);
  return /*#__PURE__*/_jsxs("figure", _objectSpread(_objectSpread({
    ref: playerRef,
    role: "presentation",
    className: cn('cp-container inline-flex items-center justify-center relative w-full max-h-screen bg-black', className),
    onMouseDown: onMouseDown,
    onMouseMove: onMouseMove,
    onMouseEnter: onMouseMove,
    onMouseLeave: hideUi,
    onTouchStart: onTouch,
    onTouchMove: onTouch,
    onTouchEnd: hideUi
  }, htmlProps), {}, {
    children: [/*#__PURE__*/_jsx(Components.Ratio, {
      poster: poster,
      orientation: orientation,
      aspectRatio: aspectRatio,
      className: poster && !isIOS && !isStarted ? 'z-1' : '-z-1 opacity-0'
    }), !isIOS && isLoading && (_div || (_div = /*#__PURE__*/_jsx("div", {
      className: "absolute inset-0 inline-flex items-center justify-center cp-loader z-4",
      children: /*#__PURE__*/_jsx(Loader, {
        isWhite: true
      })
    }))), /*#__PURE__*/_jsxs("div", {
      className: cn('cp-player inset-0', isFullscreen ? 'fixed' : 'absolute'),
      children: [/*#__PURE__*/_jsx(Components.StyledVideo, {
        controls: isIOS,
        poster: isIOS ? poster : undefined
      }), playerError && (_Components$ErrorOver || (_Components$ErrorOver = /*#__PURE__*/_jsx(Components.ErrorOverlay, {}))), !isIOS && !playerError && /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(Components.Gradient, {
          visibleUi: visibleUi,
          isMd: playerSize.matches.md
        }), _Components$Overlay || (_Components$Overlay = /*#__PURE__*/_jsx(Components.Overlay, {})), !hideLogo && (_Components$Logo || (_Components$Logo = /*#__PURE__*/_jsx(Components.Logo, {})))]
      }), /*#__PURE__*/_jsx(Components.TopControls, {
        isIOS: isIOS
      }), !isIOS && /*#__PURE__*/_jsxs(Fragment, {
        children: [isReady && !playerError && (!endOverlay || !isEnded) && (_Components$MiddleCon || (_Components$MiddleCon = /*#__PURE__*/_jsx(Components.MiddleControls, {}))), isStarted && !playerError && (!endOverlay || !isEnded) && (_Components$BottomCon || (_Components$BottomCon = /*#__PURE__*/_jsx(Components.BottomControls, {}))), _Components$Menu || (_Components$Menu = /*#__PURE__*/_jsx(Components.Menu, {})), (withLowQualityWarning || withManualHighQualityWarning) && (currentSource === null || currentSource === void 0 ? void 0 : currentSource.isHls) && (_Components$QualityWa || (_Components$QualityWa = /*#__PURE__*/_jsx(Components.QualityWarning, {}))), currentExternalSubtitles && !hasVisibleTextTrack && /*#__PURE__*/_jsx(Components.ExternalSubtitles, {
          currentExternalSubtitles: currentExternalSubtitles
        }), isReady && !hiddenNotes && !!(publicNotes !== null && publicNotes !== void 0 && publicNotes.length) && /*#__PURE__*/_jsx(Components.PublicNotes, {
          publicNotes: publicNotes
        }), (header === null || header === void 0 ? void 0 : (_header$back = header.back) === null || _header$back === void 0 ? void 0 : _header$back.confirmation) && /*#__PURE__*/_jsx(Components.LeaveConfirmation, {
          confirmation: header.back.confirmation
        }), isReady && !endOverlay && (nextVideo === null || nextVideo === void 0 ? void 0 : nextVideo.play) && /*#__PURE__*/_jsx(Components.SkipButton, {
          nextVideoTitle: nextVideo.title
        }), nextVideo && inactivity && !inactivity.ignore && /*#__PURE__*/_jsx(Components.IdleScreen, {
          inactivity: inactivity
        }), showGeneratedAI && (_Components$GenerateN || (_Components$GenerateN = /*#__PURE__*/_jsx(Components.GenerateNote, {})))]
      })]
    })]
  }));
};
export default CrehanaPlayer;